<template>
  <div id="edit_delete_model" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content closefriend-modal p-0 overflow-hidden" style="border-radius: 16px; border: 1px solid rgba(255,255,255,0.1);">
        
        <button type="button" class="close position-absolute" style="right: 20px; top: 15px; z-index: 1050; color: #fff; font-size: 35px; opacity: 1; text-shadow: 0 0 10px rgba(0,0,0,0.8);" data-dismiss="modal" aria-label="Close" @click="$emit('cancel')">
          <span aria-hidden="true">×</span>
        </button>

        <div class="row m-0 flex-column flex-md-row">
          <!-- Preview Section -->
          <div class="col-12 col-md-7 p-0 d-flex align-items-center justify-content-center" style="min-height: 300px; background: #000;">
            <template v-if="content">
              <img v-if="content.type === 'IMAGE'" :src="content.cdnUrl" class="img-fluid" style="max-height: 70vh; width: 100%; object-fit: contain;">
              <video v-else-if="content.type === 'VIDEO'" :src="content.cdnUrl" class="img-fluid" style="max-height: 70vh; width: 100%; object-fit: contain;" controls autoplay muted></video>
              <div v-else class="text-white text-center py-5">
                <img src="@/assets/images/download.png" style="width: 64px; opacity: 0.7;">
                <h5 class="mt-3 text-white-50">{{ content.ext || 'File Document' }}</h5>
              </div>
            </template>
          </div>

          <!-- Options Section -->
          <div class="col-12 col-md-5 p-4 d-flex flex-column justify-content-center" style="background: #111;">
            
            <div v-if="content" class="mb-4 text-center">
              <div class="d-flex justify-content-center align-items-center mb-2">
                <span v-if="content.pinned" class="badge badge-warning text-dark mr-2">Pinned</span>
                <span v-if="content.price > 0" class="badge badge-success">${{ content.price }}</span>
                <span v-else class="badge badge-secondary">Free</span>
              </div>
              <p class="text-white font-size-14 font-weight-300" style="max-height: 120px; overflow-y: auto;">
                {{ content.description || 'No description provided.' }}
              </p>
            </div>

            <div class="my-2 d-flex flex-column align-items-center w-100">
              <button type="button" @click="$emit('edit')" class="btn stella-btn gradient-a rounded-pill font-weight-500 mb-3" data-dismiss="modal" style="width: 160px; padding: 8px 16px !important;">
                <span class="text-white font-size-14 font-weight-600">Edit</span>
              </button>
              <button type="button" @click="$emit('archive')" class="btn stella-btn btn-warning rounded-pill font-weight-500 mb-3" data-dismiss="modal" style="width: 160px; padding: 8px 16px !important;">
                <span class="font-size-14 font-weight-600">Archive</span>
              </button>
              <button type="button" @click="$emit('delete')" class="btn stella-btn btn-danger rounded-pill font-weight-500" data-dismiss="modal" style="width: 160px; padding: 8px 16px !important;">
                <span class="font-size-14 font-weight-600">Delete</span>
              </button>
            </div>
            
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelEditDelete",
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  methods: {
    show() {
      $('#edit_delete_model').modal();
    },
    hide() {
      $('#edit_delete_model').modal('hide');
    }
  }
}
</script>


